<div class="container-fluid px-0">
  <form dir="{{ direction }}" [formGroup]="customerFormGroup" appTrackForm>
    <div class="row mt-t-20">
      @if (NationalAddressRequired) {
        <div class="col-12">
          <div class="alert alert-blue w-100">
            <mat-icon class="text-blue mx-1 flex-shrink-0">info</mat-icon>
            <div class="d-flex align-items-start flex-column">
              <b translate>Verify your location</b>
              <div translate>Enter_your_National_Address_Alert_Box</div>
            </div>
          </div>
        </div>
      }
      <div class="col-md-6 address-details order-2 order-md-1">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-col-div cd">
              <mat-label translate>Phone Number</mat-label>
              <ahoy-phone-input
                formControlName="CustomerPhone"
              ></ahoy-phone-input>
            </div>
          </div>

          <div class="col-lg-12">
            <div
              [hidden]="configurations?.hideAddressName"
              class="form-col-div"
            >
              <div>
                <mat-label><span translate>Address Name</span></mat-label>
                <mat-form-field class="address-name" appearance="outline">
                  <input
                    matInput
                    [placeholder]="'Address Name' | translate"
                    formControlName="AddressName"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div
              [hidden]="configurations?.hideCustomerName"
              class="form-col-div"
            >
              <div>
                <mat-label><span translate>Customer Name</span></mat-label>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    [placeholder]="'Customer Name' | translate"
                    formControlName="CustomerName"
                  />
                </mat-form-field>
              </div>
            </div>
            <div [hidden]="configurations?.hideContactCustomer">
              <mat-checkbox
                color="primary"
                disableRipple="true"
                formControlName="DontContactCustomer"
              >
                <span translate>Don't Contact the customer</span>
              </mat-checkbox>
            </div>
          </div>
        </div>
        @if (NationalAddressRequired) {
          <div class="row">
            <div class="col-lg-12">
              <div class="form-row mt-2 mb-2">
                <div class="col-12">
                  <mat-label
                    ><span translate>National Address Code</span></mat-label
                  >
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      [placeholder]="'e.g. ABCD1234' | translate"
                      formControlName="nationalAddress"
                    />
                    <mat-hint>
                      <span translate>National_Address_Hint</span>
                    </mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="row">
          <div class="col-lg-12">
            <div class="row form-row mt-2">
              <div class="col-md-6">
                <mat-label><span translate>Latitude</span></mat-label>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    placeholder="Latitude"
                    formControlName="CustomerLatitude"
                  />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-label><span translate>Longitude</span></mat-label>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    placeholder="Longitude"
                    formControlName="CustomerLongitude"
                  />
                </mat-form-field>
              </div>
            </div>
            <mat-error class="latLon-error">
              <small>{{ invalidLatLonError }}</small>
            </mat-error>
          </div>
        </div>

        <app-address-details-tabs #addressTabs></app-address-details-tabs>

        <div
          class="row d-flex mt-2"
          [hidden]="configurations?.hideTagLocationName"
        >
          <div class="col-lg-12">
            <mat-label><span translate>Tag the Location</span></mat-label>
            <div
              class="toggle-container mt-1"
              formGroupName="locationNameFormGroup"
            >
              <mat-button-toggle-group
                #group="matButtonToggleGroup"
                multiple="false"
                formControlName="locationName"
                [hideSingleSelectionIndicator]="true"
                [value]="selectedTagName"
              >
                @for (array of tagLocationName; track array) {
                  <mat-button-toggle
                    class="tag-location-btn"
                    (change)="onLocationNameTagChange(array.name)"
                    [value]="array.name"
                  >
                    <div class="tab-text">
                      <!-- @if (array.icon) {
                        <mat-icon>{{ array.icon }}</mat-icon>
                      } -->
                      <span class="tab-title ng-star-inserted">{{
                        array.name | translate
                      }}</span>
                    </div>
                  </mat-button-toggle>
                }
              </mat-button-toggle-group>
            </div>
          </div>
          @if (selectedTagName == 'Other') {
            <div class="col-lg-12">
              <div class="form-col-div">
                <mat-label><span translate>Save As</span></mat-label>
                <mat-form-field class="address-name" appearance="outline">
                  <input
                    matInput
                    [placeholder]="'Save As' | translate"
                    formControlName="customLocationName"
                    maxlength="30"
                  />
                  <mat-hint>
                    <span translate>Name cannot exceed 30 characters.</span>
                  </mat-hint>
                </mat-form-field>
              </div>
            </div>
          }
          @if (showSaveToAddressBook) {
            <div class="row">
              <div class="col-lg-12">
                <mat-checkbox
                  color="neutral"
                  [(ngModel)]="saveToAddressBook"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <span translate>Save to address book</span>
                </mat-checkbox>
              </div>
            </div>
          }
        </div>
      </div>
      <div
        class="col-md-6 map-col order-1 order-md-2"
        [class.has-alert]="NationalAddressRequired"
      >
        <div class="map-parent">
          <div class="map-search">
            <div class="form-col-div cd mt-2">
              <mat-label
                ><span translate
                  >Search or Select Your Location</span
                ></mat-label
              >
              <mat-form-field appearance="outline">
                <input
                  type="text"
                  #addresstext
                  matInput
                  [matAutocomplete]="auto"
                  formControlName="CustomerAddress"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="displayAddress"
                  (optionSelected)="addressSelected()"
                >
                  @if (isLoading) {
                    <mat-option class="is-loading">
                      <mat-spinner diameter="50"></mat-spinner>
                    </mat-option>
                  }
                  @if (!isLoading) {
                    @for (address of addresses; track address) {
                      <mat-option [value]="address">
                        <span>{{ address.title }}</span>
                      </mat-option>
                    }
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <div class="map-container" #mapContainer></div>
          @if (isValidButRemote || !isLocationValid) {
            <div>
              <span
                [ngClass]="{
                  remoteLocation: isValidButRemote,
                  invalidLocation: !isLocationValid,
                }"
              >
                {{ locationValidationMessage }}
              </span>
            </div>
          }
        </div>
      </div>
    </div>
  </form>
</div>
